import { useQuery } from '@tanstack/react-query';
import qs from 'qs';

import { useApi, useAuth } from '../../hooks';
import { RosterPatient } from '../../models/user';

type UserProgressFilter = 'NEW' | 'ON TRACK' | 'AT RISK' | 'OFF TRACK' | 'INACTIVE' | 'CANCELED'

export const useUsersList = ({
  care_team_member_id,
  coach_id,
  status,
  offset,
  limit,
}: {
  care_team_member_id?: string,
  coach_id?: string,
  status?: UserProgressFilter[]
  offset?: number
  limit?: number
}) => {
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const queryStr = qs.stringify({care_team_member_id, coach_id, status, offset, limit}, {arrayFormat: 'repeat'})

  const fetchUsersList = async () => {
    const requestObj = {
      route: `/private/coach/users${queryStr ? `?${queryStr}`: ''}`,
      token: userToken,
    };

    return await api(requestObj);
  };

  // RosterPatient, not User: the roster screen filters on several dimensions
  // (risk stratification, care-coordination status, RD/pharmacist assignment)
  // the real endpoint does not return yet — they come from fixtures today.
  // See MockedRosterFields in models/user.ts.
  const { data, isLoading, isError } = useQuery<{ users: RosterPatient[] }, Error>(
    ['hc-users-list', userToken, queryStr],
    () => fetchUsersList(),
    {
      enabled: isAuthenticated && !loading && !!userToken,
      refetchOnWindowFocus: false,
    }
  );

  const pageLength = data?.users?.length

  return { usersList: data?.users, isLoading, isError, pageLength };
};
